import React, { useEffect, useRef, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';

function LeftDrawerSlide({
  children,
  isVisible,
  onClose,
  hideClose,
  hideExternalScroll,
  className,
}) {
  const [width, setWidth] = useState(window.innerWidth);
  // updated due to 150% zooming
  // const breakpoint = 768;
  const breakpoint = 1024;

  useEffect(() => {
    window.addEventListener('resize', () => setWidth(window.innerWidth));
  }, []);

  return isVisible ? (
    width < breakpoint ? (
      <MobileComponent
        className={className}
        children={children}
        onClose={onClose}
        hideClose={hideClose}
        isVisible={isVisible}
        hideExternalScroll={hideExternalScroll}
      />
    ) : (
      <DesktopComponent
        className={className}
        children={children}
        onClose={onClose}
        hideClose={hideClose}
        isVisible={isVisible}
        hideExternalScroll={hideExternalScroll}
      />
    )
  ) : null;
}

export default LeftDrawerSlide;

function MobileComponent({
  children,
  onClose,
  isVisible,
  hideClose,
  className,
  ...rest
}) {
  const scrollRef = useRef(null);
  useEffect(() => {
    document.body.style.overflow = isVisible ? 'hidden' : 'unset';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isVisible]);
  return (
    <div
      className={`${className} tk-left-drawer col-12 col-lg-3 col-md-6 col-xl-3`}
    >
      <div
        className="tk-left-drawer__close-icon tk-dialog__btn-close tv-buttons__type icon-close"
        onClick={onClose}
        style={{ display: hideClose ? 'none' : 'block' }}
      />
      {rest.hideExternalScroll ? (
        <>{children}</>
        ) : (
          <Scrollbars ref={scrollRef}>{children}</Scrollbars>
        )}
    </div>
  );
}

function DesktopComponent({
  children,
  onClose,
  hideClose,
  className,
  ...rest
}) {
  const scrollRef = useRef(null);
  return (
    <div
      className={`${className} tk-left-drawer col-12 col-lg-3 col-md-6 col-xl-3`}
    >
      <div
        className="tk-left-drawer__close-icon tk-dialog__btn-close tv-buttons__type icon-close"
        onClick={onClose}
        style={{ display: hideClose ? 'none' : 'block' }}
      />
      {rest.hideExternalScroll ? (
        <>{children}</>
        ) : (
          <Scrollbars ref={scrollRef}>{children}</Scrollbars>
        )}
    </div>
  );
}
